export default "__VITE_ASSET__C94t2XvQ__"